import { useForm } from "react-hook-form";
import {
  SOCIAL_LOGIN,
  USER_LOGIN,
  fetchData,
  EMAIL_EXISTS,
} from "../../Service";
import { toast } from "react-toastify";
import { useContext, useEffect } from "react";
import { Context } from "../../Context";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { setCookie } from "nookies";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [showPassword, setShowPassword] = useState(true);
  const navigate = useNavigate();

  const [context, setContext] = useContext(Context);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setError,
    trigger,
    setValue,
  } = useForm();

  useEffect(() => {
    const handleModalOpen = () => {
      setTimeout(() => {
        const passwordField = document.querySelector('input[name="password"]');
        if (passwordField) {
          passwordField.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }, 200); // Give it some time to autofill
    };

    const modal = document.getElementById("loginModal");
    if (modal) {
      modal.addEventListener("shown.bs.modal", handleModalOpen);
    }
    reset();
    return () => {
      if (modal) {
        modal.removeEventListener("shown.bs.modal", handleModalOpen);
      }
    };
  }, []);

  const loginUser = (data) => {
    data = {
      ...data,
      remember_me: true,
    };

    fetchData(USER_LOGIN, "POST", data, false, false, (res) => {
      if (res?.status && res?.status_code == 200) {
        toast.success("Logged in successfully.");
        setContext((prevValue) => ({
          ...prevValue,
          user: res?.data?.user_data,
          userToken: res?.data?.access_token,
          loginLocation: null,
        }));

        localStorage.setItem("__nristoken", res?.data?.access_token);
        // 45 minutes in milliseconds
        const SESSION_DURATION = 45 * 60 * 1000;

        // After a successful login:
        const expiresAt = new Date().getTime() + SESSION_DURATION;
        setCookie(null, "NrisSessionTime", expiresAt.toString(), {
          maxAge: 2 * 24 * 60 * 60, // 2 day
          path: "/",
          domain: ".nris.com",
          secure: true,
          httpOnly: false,
          sameSite: "lax",
        });
        localStorage.setItem("NrisSessionTime", expiresAt.toString());
        localStorage.setItem(
          "__nrisuser",
          JSON.stringify(res?.data?.user_data)
        );

        setCookie(null, "NrisToken", res?.data?.access_token, {
          maxAge: 2 * 24 * 60 * 60, // 2 day
          path: "/",
          domain: ".nris.com",
          secure: true,
          httpOnly: false,
          sameSite: "lax",
        });

        setCookie(null, "NrisUser", JSON.stringify(res?.data?.user_data), {
          maxAge: 2 * 24 * 60 * 60, // 2 day
          path: "/",
          domain: ".nris.com",
          secure: true,
          httpOnly: false,
          sameSite: "lax",
        });

        window.$("#loginModal").modal("hide");
        if (context?.loginLocation) {
          if (context?.loginLocation.model) {
            window.$(`${context?.loginLocation?.name}`).modal("show");
            console.log(context?.loginLocation?.name);
          } else {
            navigate(context?.loginLocation?.url, {
              state: context?.loginLocation?.state,
            });
          }
        }
      } else {
        if (res?.message == "email not verified.") {
          toast.error("Please verify your email address.");
        } else if (res?.message == "Incorrect Password...") {
          toast.error("Password is incorrect.");
        } else {
          toast.error("Email does not exist. Please register to login.");
        }
      }
    });
  };

  const handleGoogleResponse = async (response) => {
    console.log("Google login response:", response);

    if (response?.access_token) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${response?.access_token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch("https://www.googleapis.com/oauth2/v2/userinfo", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result?.email) {
            // check email exits or not

            fetchData(
              EMAIL_EXISTS,
              "POST",
              { email_id: result?.email },
              false,
              false,
              (res) => {
                if (res.status && res?.status_code == 200) {
                  fetchData(
                    SOCIAL_LOGIN,
                    "POST",
                    { email_id: result?.email },
                    false,
                    false,
                    (res) => {
                      if (res.status && res?.status_code == 200) {
                        toast.success("Logged in successfully.");

                        setContext((prevValue) => ({
                          ...prevValue,
                          user: res?.data?.user_data,
                          userToken: res?.data?.access_token,
                        }));

                        localStorage.setItem(
                          "__nrisuser",
                          JSON.stringify(res?.data?.user_data)
                        );
                        localStorage.setItem(
                          "__nristoken",
                          res?.data?.access_token
                        );

                        setCookie(null, "NrisToken", res?.data?.access_token, {
                          maxAge: 2 * 24 * 60 * 60, // 2 day
                          path: "/",
                          domain: ".nris.com",
                          secure: true,
                          httpOnly: false,
                          sameSite: "lax",
                        });

                        setCookie(
                          null,
                          "NrisUser",
                          JSON.stringify(res?.data?.user_data),
                          {
                            maxAge: 2 * 24 * 60 * 60, // 2 day
                            path: "/",
                            domain: ".nris.com",
                            secure: true,
                            httpOnly: false,
                            sameSite: "lax",
                          }
                        );

                        reset();
                        window.$("#loginModal").modal("hide");
                      } else {
                        if (res?.message == "email not verified.") {
                          toast.error("Please verify your email address.");
                        } else if (res?.message == "Incorrect Password...") {
                          toast.error("Password is incorrect.");
                        } else {
                          toast.error(
                            "Email does not exist. Please register to login."
                          );
                        }
                      }
                    }
                  );
                } else {
                  setContext((prevValue) => ({
                    ...prevValue,
                    tempUserData: result,
                  }));

                  reset();
                  window.$("#loginModal").modal("hide");
                  window.$("#signupSocialMediaModal").modal("show");
                  return;
                }
              }
            );
          } else {
            toast.error("Unable to login. Please try different method.");
          }
        })
        .catch((error) => {
          toast.error("Unable to login. Please try different method.");
          console.error(error);
        });
    } else {
      toast.error("Unable to login. Please try different method.");
    }
  };

  const handleFacebookResponse = (response) => {
    console.log(response);
    if (response.accessToken) {
      if (response?.email) {
        fetchData(
          EMAIL_EXISTS,
          "POST",
          { email_id: response?.email },
          false,
          false,
          (res) => {
            if (res.status && res?.status_code == 200) {
              fetchData(
                SOCIAL_LOGIN,
                "POST",
                { email_id: response?.email },
                false,
                false,
                (res) => {
                  if (res.status && res?.status_code == 200) {
                    toast.success("Logged in successfully.");

                    setContext((prevValue) => ({
                      ...prevValue,
                      user: res?.data?.user_data,
                      userToken: res?.data?.access_token,
                    }));

                    localStorage.setItem(
                      "__nrisuser",
                      JSON.stringify(res?.data?.user_data)
                    );
                    localStorage.setItem(
                      "__nristoken",
                      res?.data?.access_token
                    );

                    setCookie(null, "NrisToken", res?.data?.access_token, {
                      maxAge: 2 * 24 * 60 * 60, // 2 day
                      path: "/",
                      domain: ".nris.com",
                      secure: true,
                      httpOnly: false,
                      sameSite: "lax",
                    });

                    setCookie(
                      null,
                      "NrisUser",
                      JSON.stringify(res?.data?.user_data),
                      {
                        maxAge: 2 * 24 * 60 * 60, // 2 day
                        path: "/",
                        domain: ".nris.com",
                        secure: true,
                        httpOnly: false,
                        sameSite: "lax",
                      }
                    );

                    reset();
                    window.$("#loginModal").modal("hide");
                  } else {
                    if (res?.message == "email not verified.") {
                      toast.error("Please verify your email address.");
                    } else if (res?.message == "Incorrect Password...") {
                      toast.error("Password is incorrect.");
                    } else {
                      toast.error(
                        "Email does not exist. Please register to login."
                      );
                    }
                  }
                }
              );
            } else {
              setContext((prevValue) => ({
                ...prevValue,
                tempUserData: {
                  given_name: response?.name,
                  email: response?.email,
                },
              }));

              reset();
              window.$("#loginModal").modal("hide");
              window.$("#signupSocialMediaModal").modal("show");
              return;
            }
          }
        );
      } else {
        toast.error("Unable to login. Please try different method.");
      }
    } else {
      console.log("Facebook login failed:", response);
      toast.error("Unable to login. Please try different method.");
    }
  };

  const handleSocialError = () => {
    toast.error("Unable to login. Please try different method.");
  };

  function GoogleAuthButton() {
    const login = useGoogleLogin({
      onSuccess: (response) => {
        handleGoogleResponse(response);
      },
      onError: () => {
        handleSocialError();
      },
      scope: "email",
    });

    return (
      <button
        onClick={login}
        className="btn btn-sm social-login hover-up bg-transparent"
      >
        <img src="/assets/images/icons/google.svg" title="Google" alt="..." />
        Google
      </button>
    );
  }
  return (
    <div
      className="modal fade pe-0"
      id="loginModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content apply-job-form">
          <button
            className="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              reset();
            }}
          ></button>
          <div className="modal-header d-block text-center border-bottom-0">
            <a href="#!">
              <img
                title="NRIS"
                src="/assets/images/logo.png"
                width="150px"
                alt="..."
              />
            </a>
            <h5 className="text-brand-1 text-capitalize">
              Login into your account
            </h5>
          </div>
          <div className="modal-body px-4 pb-0">
            <div className="row">
              <div className="col-6 mb-2">
                <GoogleOAuthProvider
                  clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                >
                  <GoogleAuthButton />
                </GoogleOAuthProvider>
              </div>
              <div className="col-6 mb-2">
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
                  fields="name,email,picture"
                  callback={handleFacebookResponse}
                  textButton={`${" "}Facebook`}
                  cssClass="btn btn-sm social-login hover-up bg-transparent"
                  icon="fa-facebook fb-color"
                />
              </div>
            </div>
            <form
              className="login-register text-start mt-20 pb-30 needs-validation"
              onSubmit={handleSubmit(loginUser)}
            >
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="divider-text-center">
                    <span>Or continue with</span>
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <label>
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    className={`form-control bg-transparent ${errors.email_id && "is-invalid"
                      }`}
                    autoComplete="email"
                    maxLength={120}
                    placeholder="Email"
                    type="email"
                    {...register("email_id", {
                      required: { value: true, message: "Email is required." },
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Email is invalid.",
                      },
                    })}
                  />
                  {errors.email_id && (
                    <div class="invalid-feedback">
                      {errors.email_id.message}
                    </div>
                  )}
                </div>
                <div className="col-12 mb-2">
                  <label htmlFor="password">
                    Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      maxLength={20}
                      id="password"
                      className={`form-control bg-transparent ${errors.password ? "is-invalid" : ""
                        }`}
                      placeholder="Password"
                      type={!showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      {...register("password", {
                        required: {
                          value: true,
                          message: "Password is required.",
                        },
                        minLength: {
                          value: 8,
                          message: "Password must be at least 8 characters.",
                        },
                        pattern: {
                          value:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
                          message:
                            "Password must contain uppercase, lowercase, number, and special character.",
                        },
                      })}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pasted = e.clipboardData.getData("text").replace(/\s/g, "");
                        setValue("password", pasted); 
                      }}
                      onChange={(e) => {
                        const cleaned = e.target.value.replace(/\s/g, "");
                        setValue("password", cleaned);
                        // trigger("password");
                      }}
                    />
                    <button
                      type="button"
                      className={`btn btn-outline-secondary ${errors.password ? "is-invalid" : ""
                        }`}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {!showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                  {errors.password && (
                    <div className="invalid-feedback d-block">
                      {errors.password.message}
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  {/* <label className="cb-container mb-0">
										<input type="checkbox" {...register("remember_me")} />
										<span className="color-black font12">Remember me</span>
										<span className="checkmark"></span>
									</label> */}
                </div>
                <div className="col-sm-6 text-start text-sm-end">
                  <a
                    href="#!"
                    className="text-primary font12"
                    data-bs-toggle="modal"
                    data-bs-target="#forgetPasswordModal"
                    data-bs-dismiss="modal"
                  >
                    Recover Password
                  </a>
                </div>
              </div>
              <div className=" d-block text-center mt-2">
                <button
                  className="btn btn-default hover-up m-auto"
                  type="submit"
                  name="login"
                >
                  Sign In
                </button>
              </div>
            </form>
            <p className="color-black font12 text-center mb-2">
              Don't have an account?{" "}
              <a
                href="#!"
                className="text-primary "
                data-bs-toggle="modal"
                data-bs-target="#signupModal"
                data-bs-dismiss="modal"
              >
                Sign Up
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
